"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarPage;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIIconButton = _interopRequireDefault(require("../../button/UIIconButton"));

var _SimpleDate = require("../../core/SimpleDate");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _UIIcon = _interopRequireDefault(require("../../icon/UIIcon"));

var _SimpleDateTypes = require("../../types/SimpleDateTypes");

var _Locale = require("../../utils/Locale");

var _calendarUtils = require("./calendarUtils");

var _Month = _interopRequireDefault(require("./Month"));

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "CalendarPage__Wrapper",
  componentId: "sc-1dhl788-0"
})(["display:inline-block;"]);
/**
 * @param {SimpleDate} value The current selected date, or null
 * @returns {String} A string for announcing the selected date to screen readers
 */


var getAlertText = function getAlertText(value) {
  return value ? _I18n.default.text('ui.datePicker.dateSelected', {
    date: (0, _SimpleDate.toMoment)(value).format('LL')
  }) : _I18n.default.text('ui.datePicker.noDateSelected');
};

var getCalendarPage = function getCalendarPage(calendarPage, value, today) {
  if (calendarPage) return calendarPage;
  if ((0, _SimpleDate.isValid)(value)) return (0, _calendarUtils.getPageFromDate)(value);
  return (0, _calendarUtils.getPageFromDate)(today);
};

function CalendarPage(props) {
  var calendarPage = props.calendarPage,
      id = props.id,
      onCalendarPageChange = props.onCalendarPageChange,
      today = props.today,
      value = props.value,
      rest = (0, _objectWithoutProperties2.default)(props, ["calendarPage", "id", "onCalendarPageChange", "today", "value"]);
  var localeData = (0, _Locale.getLocaleData)();
  var currentCalendarPage = getCalendarPage(calendarPage, value, today);
  var month = currentCalendarPage.month,
      year = currentCalendarPage.year;
  return _react.default.createElement(Wrapper, {
    id: id
  }, _react.default.createElement("span", {
    className: "sr-only",
    "aria-live": "polite",
    "aria-atomic": true
  }, getAlertText(value)), _react.default.createElement(_Month.default, Object.assign({}, rest, {
    month: month,
    leftControl: _react.default.createElement(_UIIconButton.default, {
      "data-action": "prev-month",
      use: "transparent",
      "aria-label": _I18n.default.text('ui.datePicker.prevMonth'),
      onClick: function onClick() {
        onCalendarPageChange((0, _SyntheticEvent.default)((0, _calendarUtils.prevCalendarPage)(currentCalendarPage)));
      }
    }, _react.default.createElement(_UIIcon.default, {
      name: "left",
      size: 22
    })),
    ownerId: id,
    rightControl: _react.default.createElement(_UIIconButton.default, {
      "data-action": "next-month",
      use: "transparent",
      "aria-label": _I18n.default.text('ui.datePicker.nextMonth'),
      onClick: function onClick() {
        onCalendarPageChange((0, _SyntheticEvent.default)((0, _calendarUtils.nextCalendarPage)(currentCalendarPage)));
      }
    }, _react.default.createElement(_UIIcon.default, {
      name: "right",
      size: 22
    })),
    today: today,
    weekdayHeadings: localeData._weekdaysMin,
    weekStartDay: localeData._week.dow,
    value: value,
    year: year
  })));
}

CalendarPage.displayName = 'CalendarPage';

if (process.env.NODE_ENV !== 'production') {
  CalendarPage.propTypes = {
    calendarPage: _propTypes.default.shape({
      year: _propTypes.default.number.isRequired,
      month: _propTypes.default.number.isRequired
    }),
    id: _propTypes.default.string.isRequired,
    onCalendarPageChange: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func.isRequired,
    today: _SimpleDateTypes.SimpleDateType.isRequired,
    value: _SimpleDateTypes.SimpleDateType
  };
}

module.exports = exports.default;